import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import { LIST_VIEW_MODE } from 'Common/config';

export const List = styled.div<{
  mode: 'list' | 'grid';
}>`
  margin-bottom: ${fromTheme('spacing_xlarge')};

  ${(props) => {
    if (props.mode === LIST_VIEW_MODE.LIST) {
      return `
        display: flex;
        flex-direction: column;
        row-gap: ${fromTheme('spacing_xlarge')(props)};
      `;
    }

    return `
      @media (min-width: 450px) {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(425px, 1fr));
        gap: ${fromTheme('spacing_medium')(props)};
        align-items: stretch;

        .provider-card {
          height: 100%;
          .booking-actions,
          .booking-availability-tiles {
            align-content: end;
          }
          > div {
            height: 100%;
            grid-template-rows: auto 1fr auto;
          }
        }
      }
    `;
  }}
`;
